import React from 'react';
import { Info } from 'lucide-react';
import { getImpersonation } from '@/lib/axiosClient';

const DEMO_FARM_NAME = 'Demo Mushroom Farm';

/**
 * Subtle top strip shown whenever the active farm is the public DEMO farm —
 * either a direct demo login (user.farm_name) or a super-admin / farm-manager
 * impersonating it. Reminds users the data auto-resets daily.
 */
const DemoBanner = ({ user }) => {
  const impName = getImpersonation()?.farmName;
  const farmName = impName || user?.farm_name;
  const isDemo =
    typeof farmName === 'string' &&
    farmName.trim().toLowerCase() === DEMO_FARM_NAME.toLowerCase();

  if (!isDemo) return null;

  return (
    <div
      data-testid="demo-mode-banner"
      className="bg-amber-500 text-amber-950 px-4 py-1.5 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium"
    >
      <Info className="w-4 h-4 shrink-0" />
      <span>
        <strong>Demo Mode</strong> — this is a live sample farm. All data resets automatically every day.
      </span>
    </div>
  );
};

export default DemoBanner;
